/* eslint-disable no-param-reassign */

export default {
	setCart(state, payload) {
		state.cart = payload;
	},

	setBrand(state, payload) {
		state.brand = payload;
	},

	setBumpers(state, payload) {
		state.bumpers = payload;
	},

	setUser(state, payload) {
		state.user = payload;
	},

	setQuery(state, payload) {
		state.query = payload;
	},

	setParams(state, payload) {
		state.params = payload;
	},

	setInitialized(state, payload) {
		state.initialized = payload;
	},

	setBillingAddress(state, payload) {
		state.billingAddress = payload;
	},

	setShippingAddress(state, payload) {
		state.shippingAddress = payload;
	},

	setShippingDifferentFromBilling(state, payload) {
		state.shippingDifferentFromBilling = payload;
	},

	setBillingComponent(state, payload) {
		state.billingComponent = payload;
	},

	setBillingGateway(state, payload) {
		state.billingGateway = payload;
	},

	setErrors(state, payload) {
		state.errors = payload;
	},

	setSubmittingOrder(state, payload) {
		state.submittingOrder = payload;
	},

	setGetToken(state, payload) {
		state.getToken = payload;
	},

	setRestorePaymentForm(state, payload) {
		state.restorePaymentForm = payload;
	},

	setHandleAdyenThreeDsAction(state, payload) {
		state.handleAdyenThreeDsAction = payload;
	},

	setAwaitingThreeDs(state, payload) {
		state.awaitingThreeDs = payload;
	},

	setPassword(state, payload) {
		state.password = payload;
	},

	setEmail(state, payload) {
		state.email = payload;
	},

	setShowFormErrors(state, payload) {
		state.showFormErrors = payload;
	},

	setEmailExistsError(state, payload) {
		state.emailExistsError = payload;
	},

	setProductLimits(state, payload) {
		state.productLimits = payload;
	},

	setCheckingEmailExists(state, payload) {
		state.checkingEmailExists = payload;
	},

	setBillingPostalCodeMismatchError(state, payload) {
		state.billingPostalCodeMismatchError = payload;
	},

	setShippingPostalCodeMismatchError(state, payload) {
		state.shippingPostalCodeMismatchError = payload;
	},

	setModifyingCart(state, payload) {
		state.modifyingCart = payload;
	},

	setShowBumperDialog(state, payload) {
		state.showBumperDialog = payload;
	},

	setInitializingPaypal(state, payload) {
		state.initializingPaypal = payload;
	},

	setProcessingPaypal(state, payload) {
		state.processingPaypal = payload;
	},

	setPaymentProcessor(state, payload) {
		state.paymentProcessor = payload;
	},

	setPaymentProcessors(state, payload) {
		state.paymentProcessors = payload;
	},

	setIsEcommerce(state, payload) {
		state.isEcommerce = payload;
	},
};
